<p-card data-testid="importance-scale-card" *transloco="let t; prefix: 'project'">
  <h3
    class="text-lg font-semibold mb-4 flex items-center gap-3"
    data-testid="importance-values-header"
  >
    {{ t('steps.importanceValues') }}
    <app-directus-tooltip
      tooltipStyleClass="tooltip-bg-second-level"
      tooltipKey="projectSetting_importanceValues"
    ></app-directus-tooltip>
  </h3>

  <div class="flex flex-col gap-4">
    <div class="flex items-end gap-6">
      <div class="flex-1 min-w-64 max-w-80">
        <div class="text-md font-medium mb-4">
          {{ t('steps.importanceCategory') }}
        </div>
      </div>
      <div class="flex-1 min-w-64 max-w-80 space-y-3">
        <div class="text-center">{{ t('steps.typeOfScale') }}</div>
        <p-selectButton
          size="large"
          allowEmpty="false"
          [options]="scaleOptions"
          [ngModel]="selectedScale()"
          (onChange)="onScaleChange($event.value)"
          styleClass="w-full truncate"
          class="w-full"
          optionLabel="labelKey"
          optionValue="value"
          data-testid="scale-type-selector"
        >
          <ng-template let-item #item>
            <span [attr.data-testid]="'scale-option-' + item.value">{{ t(item.labelKey) }}</span>
            @if (selectedScale() === item.value) {
              <i class="pi pi-check ml-1" style="color: var(--color-green)"></i>
            }
          </ng-template>
        </p-selectButton>
      </div>
    </div>

    @for (cat of categoryValues(); track cat.nameKey) {
      <div class="flex items-center gap-6">
        <div class="basis-64 flex-1 min-w-64 max-w-80 truncate p-3 rounded-lg bg-third-level">
          <div class="flex justify-between items-center">
            {{ t(cat.nameKey) }}
            <app-directus-tooltip
              [tooltipKey]="cat.tooltipKey"
              tooltipStyleClass="tooltip-bg-second-level"
            ></app-directus-tooltip>
          </div>
        </div>
        <div class="basis-64 flex-1 min-w-64 max-w-80">
          <input
            pInputText
            [value]="cat.displayValue"
            disabled
            class="w-full text-white!"
            [ngClass]="{'text-right': selectedScale() === 'exp'}"
            [attr.data-testid]="'category-value-' + cat.nameKey"
          />
        </div>
      </div>
    }
  </div>
  @if (shouldShowSaveButton()) {
    <div class="flex justify-end gap-2 mt-4">
      <app-project-step-save-button
        [loading]="isSaving()"
        [disabled]="isSaving()"
        (clicked)="onSubmit()"
      ></app-project-step-save-button>
    </div>
  }
</p-card>
